module.exports = __webpack_public_path__ + "img/logo.cc38d146.svg";